import React from 'react';
import Button from '../../ui/Button';

const AutoInvoiceActions = ({ handleInvoiceSubmit }) => {
  return (
    <div className="p-4 sm:p-6 bg-gray-50/50 rounded-b-xl flex flex-col sm:flex-row items-center justify-between gap-4">
      <div className="text-[13px] text-gray-500">
        Уверете се, че данните са коректни преди да запазите
      </div>
      <Button variant="primary" className="w-full sm:w-auto min-w-[140px]" onClick={handleInvoiceSubmit}>
        Създаване
      </Button>
    </div>
  );
};

export default AutoInvoiceActions;
